import { http } from '@/api/Connect';
import { BASE_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import {
  ECopyStakeIntegrationMode,
  TCopystakeIntegration,
  GameIntegration,
  TCopystakeAggregation,
  TCopystakeOperatorAggregatorOperatorParams,
  TCopystakeOperatorAggregatorCasinoParams
} from '@/api/schema';

const API_INTEGRATION = (): string => `${BASE_OPERATOR()}/integration`;

export async function getCopystakeIntegration(): Promise<TCopystakeIntegration> {
  return http
    .get(API_INTEGRATION(), {
      cacheTime: 0
    })
    .then(({ data }: AxiosResponse<TCopystakeIntegration>) => data);
}

export async function updateCopystakeIntegration(
  params: TCopystakeIntegration
): Promise<void> {
  return http.put(API_INTEGRATION(), null, { params });
}

export async function updateCopystakeIntegrationMode(
  mode: ECopyStakeIntegrationMode
): Promise<unknown> {
  return http.patch(`${API_INTEGRATION()}/integration-mode`, null, {
    params: { mode }
  });
}

export async function updateCopystakeGameIntegrationType(
  params: GameIntegration
): Promise<unknown> {
  return http.put(`${API_INTEGRATION()}/game-integration-type`, null, {
    params
  });
}

export async function getCopystakeAggregationConfig(): Promise<TCopystakeAggregation> {
  return http
    .get(`${API_INTEGRATION()}/integration-config`, {
      cacheTime: 0
    })
    .then(({ data }: AxiosResponse<TCopystakeAggregation>) => data);
}

export async function updateCopystakeAggregatorOperatorConfig(
  params: TCopystakeOperatorAggregatorOperatorParams
): Promise<unknown> {
  return http.put(`${API_INTEGRATION()}/aggregator-operator-config`, null, {
    params
  });
}

export async function updateCopystakeAggregatorCasinoConfig(
  params: TCopystakeOperatorAggregatorCasinoParams
): Promise<unknown> {
  return http.put(`${API_INTEGRATION()}/aggregator-casino-config`, null, {
    params
  });
}

export async function updateCopystakeAggregationAggregatorMode(
  active: boolean
): Promise<unknown> {
  return http.patch(`${API_INTEGRATION()}/aggregator-activation`, null, {
    params: { active }
  });
}

export async function updateCopystakeAggregationCasinoMode(
  active: boolean
): Promise<unknown> {
  return http.patch(`${API_INTEGRATION()}/casino-activation`, null, {
    params: { active }
  });
}
